import { IProject } from '../../../shared/interfaces/projects/IProject';
import { IBaseModel } from '../../../shared/interfaces/shared/IBase';
import { IPagination } from '../../../shared/interfaces/shared/IPagination';
import { requests } from '../../../utils/api/api.service';
import { PROJECT_URL } from '../../../utils/api/endpoints';

export const AdminProjectsService = {
  get: (pagination: IPagination): Promise<IBaseModel<IProject[]>> =>
    requests.get(PROJECT_URL, pagination),
  getSingle: (id: number): Promise<IProject> =>
    requests.get(`${PROJECT_URL}/${id}`),
  create: (params: IProject) => requests.post(PROJECT_URL, params),
  update: (params: IProject, id: number) =>
    requests.put(`${PROJECT_URL}/${id}`, params),
  delete: (id: number) => requests.delete(`${PROJECT_URL}/${id}`),
};
